import { Component, type EventEmitter, Prop, h, Event, Listen, State } from '@stencil/core';
import { GenericCardTitle } from '../../../../new-result-cards/generic-subcomponents/generic-card-title/generic-card-title';
import { UiaasSearchLabelList } from '../../../../result-cards/subcomponents/uiaas-search-label-list';
import type { SearchApiDocument } from '../../../../../../api/SearchApi';
import { GenericCardDescription } from '../../../../new-result-cards/generic-subcomponents/generic-card-description/generic-card-description';
import { GenericCardEventsLayer } from '../../../../new-result-cards/generic-subcomponents/generic-card-event-layer/generic-card-event-layer';
import type { SearchProduct } from '../../../../../../api/model/response/documents/public/Product';
import { ResultCardType } from '../../../../new-result-cards/public/product-card/helpers/helpers';
import type { SearchResultClickEvent } from '../../../SearchResultClickEvent';
import {Strategies} from '../../../../../strategies/Strategies';

@Component({
  tag: 'dashboard-company-item',
  shadow: false,
  styleUrl: 'dashboard-company-tile.scss',
})
export class DashboardCompanyItem {
    @Prop() readonly doc: SearchApiDocument;
    @Prop() readonly index: number;
    @Prop() readonly strategies: Strategies;
    @Prop() readonly section: string;
    @Prop() readonly lazyLoadImages: boolean = false;

    @State() accessibilityMode;

    @Event({
      eventName: 'search:ResultCardClick',
      composed: true,
      cancelable: true,
      bubbles: true,
    })
      resultCardClickEventEmitter: EventEmitter<SearchResultClickEvent>;

    @Listen('uiaas:accessibility', { target: 'window' })
    handleAccessibility(ev) {
        this.accessibilityMode = ev.detail;
    }

    connectedCallback() {
        const htmlElement = document.querySelector('html');
        const isAccessibilityOn = htmlElement.classList.contains('se2-accessibility');
        this.accessibilityMode = isAccessibilityOn;
    }

    render() {
        const accessibilityModeClass = this.accessibilityMode ? '--accessibility' : '';

        return (
          <div class="company-item__container">
            <GenericCardEventsLayer
              clickEmitter={this.resultCardClickEventEmitter}
              doc={this.doc as unknown as SearchProduct}
              index={this.index}
              resutCardType={ResultCardType.Basic}
              section={this.section}
            >
              <a href={this.doc.url} tabindex="0">
                <GenericCardTitle
                  url={this.doc.url}
                  text={this.doc.title}
                  strategies={this.strategies}
                />
                <div class="document__label-panel">
                  <UiaasSearchLabelList
                    list={[
                      {
                        value: this.doc?.category?.CT_CAT,
                        customValueClass: 'document__category' + accessibilityModeClass,
                      },
                    ]}
                  />
                </div>
                <GenericCardDescription
                  description={this.doc.description}
                />
              </a>
            </GenericCardEventsLayer>
          </div>
        );
    }
}
